export enum ArticleViewType {
    ONE_PAGE = "one page",
    GROUP_PAGE = "group page",
    INDIVIDUAL_PAGE = "individual page"
}